import { tokenStorage } from "../lib/token-storage";

/**
 * 토큰 조회 Use Case
 * 저장된 토큰 조회 및 검증 (환경변수 설정 키 사용)
 */
export class GetTokenUseCase {
  /**
   * 액세스 토큰 조회
   */
  getAccessToken(): string | null {
    return tokenStorage.getAccessToken();
  }

  /**
   * 리프레시 토큰 조회
   */
  getRefreshToken(): string | null {
    return tokenStorage.getRefreshToken();
  }

  /**
   * 프로필 ID 조회
   */
  getProfileId(): string | null {
    return tokenStorage.getProfileId();
  }

  /**
   * 토큰 존재 여부 확인
   */
  hasToken(): boolean {
    return !!this.getAccessToken();
  }

  /**
   * 모든 토큰 정보 조회
   */
  getAllTokens() {
    return tokenStorage.getAllTokens();
  }
}

export const getTokenUseCase = new GetTokenUseCase();
